import React, { useContext } from "react";
import { SigninModal } from "~/src/components/auth/SignInModal";
import SignInModalStateContext from "~/src/components/auth/SignInModalStateContext";

export default function GlobalSignInModal() {
  const context = useContext(SignInModalStateContext);

  return <SigninModal isOpen={context.isOpen} onRequestClose={context.close} onSignIn={context.close} />;
}
